export const productsTableWidths = {
  id: 136,
  product: 777,
  activeSkus: 135,
  inventory: 140,
  sold: 112,
  revenue: 120,
  department: 185,
  addedToMarketplace: 150,
  store : 331
}